import type { Key } from "react-aria-components";

import { useResolveBrands } from "@/features/users/hooks/useResolveBrands";
import { useResolveRequests } from "@/features/users/hooks/useResolveRequests";

import { useGetBrandsByUserId } from "../hooks/useGetBrandsByUserId";
import { useGetRequestsByUserId } from "../hooks/useGetRequestsByUserId";
import { TagListField } from "./TagListField";

interface ProfileCollaboratorFieldsProps {
  isDisabled?: boolean;
  onBrandChange?: (brandIds: Key[]) => void;
  onRequestChange?: (requestIds: Key[]) => void;
  userId: number | string;
  viewedUserProjectIds?: number[];
}

export function ProfileCollaboratorFields({
  isDisabled = true,
  onBrandChange,
  onRequestChange,
  userId,
  viewedUserProjectIds,
}: ProfileCollaboratorFieldsProps) {
  const { data: requests } = useGetRequestsByUserId(userId);
  const { data: brands } = useGetBrandsByUserId(userId);
  const { data: availableBrands } = useResolveBrands(viewedUserProjectIds);
  const { data: availableRequests } = useResolveRequests(viewedUserProjectIds);

  return (
    <>
      <TagListField
        className="col-span-full"
        emptyMessage="No requests assigned"
        getItemHref={(id) => `/requests/${id}/edit`}
        isDisabled={isDisabled}
        items={requests}
        label="Assigned requests"
        onItemsChange={onRequestChange}
        options={availableRequests?.map((r) => ({
          id: r.requestId,
          name: r.requestName,
        }))}
      />

      <TagListField
        className="col-span-full"
        emptyMessage="No brands assigned"
        getItemHref={(id) => `/brands/${id}/overview`}
        isDisabled={isDisabled}
        items={brands}
        label="Brands"
        onItemsChange={onBrandChange}
        options={availableBrands?.map((b) => ({
          id: b.brandId,
          name: b.brandName,
        }))}
      />
    </>
  );
}
